Bizfly = {
    conf: {
        url: '',
        request_url: {},
        url_embeded : "",
        base_url : ''
    },

    init: function () {
        this.conf.url = window.location.href;
        this.conf.url_embeded = window.location.href;
        this.conf.request_url = Bizfly.getRequestUrl(window.location.href);
        this.conf.base_url = this.getDomain(document.getElementById('tk-embed').getAttribute('src'));
    },

    getRequestUrl: function(url) {
        var vars = {};
        var parts = url.replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function(m,key,value) {
                vars[key] = value;
            });
        return vars;
    },

    getDomain: function (url) {
        var base_url = new URL(url);
        return base_url.protocol + '//' + base_url.hostname;
    },

    //handler post message
    bindEvent: function (element, eventName, eventHandler) {
        if (element.addEventListener){
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    },

    autoHeight: function () {
        // post message set chiều cao
        Bizfly.bindEvent(window, 'message', function (e) {
            if(e.data != undefined && e.data.bizfly_ticket_support != undefined) {
                let height = e.data.bizfly_ticket_support.height;
                if (height > 0) {
                    let h = height + 30;
                    document.head.insertAdjacentHTML(
                        "beforeend",
                        `<style>#ticket-support-embed { height: `+ h +`px }</style>`
                    )
                }
            }
            
        });
    },

    buildIframe: function (data, private_key) {
        for (let key of Object.keys(data)) {
            data[key] = encodeURIComponent(data[key]);
        }
        let data_base64 = Bizfly.utf8_to_b64(JSON.stringify(data));
        let hmac = CryptoJS.HmacSHA512(data_base64, private_key).toString();
        let link = Bizfly.conf.base_url + '/support/embed/form?data=' + data_base64 + '&hmac=' + hmac;
        let iframe = '<iframe src="' + link + '" frameborder="0" height="100%" width="100%"></iframe>';
        document.getElementById('ticket-support-embed').innerHTML = iframe;
        Bizfly.autoHeight(); //post message set height
        return iframe;
    },

    utf8_to_b64: function( str ) {
        return window.btoa(unescape(encodeURIComponent(str)));
    }
}

function embed(){
    var d = document;
    var url = TicketSupportInit.url_embeded =  window.location.href;
    var req_parent = Bizfly.getRequestUrl(url);
    var utm_source = req_parent.utm_source;

    TicketSupportInit.utm_source  = typeof utm_source != "undefined" ? utm_source : '';
    TicketSupportInit.url_embeded = typeof url != "undefined" ? url : '';

    var crypto_dcn = Bizfly.conf.base_url + '/libs/crypto/rollups/hmac-sha512.js';
    var script = d.createElement("script");
    script.src = crypto_dcn;
    d.head.appendChild(script);

    script.onload = function(e){
        Bizfly.buildIframe(TicketSupportInit, TicketSupportInit.id); // JS
    };
}

window.onload = function() {
    Bizfly.init();
    embed();
}
